import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["networkButton", "newSmartSearchForm", "entriesContainer", "hashtagInputContainer", "handleInputContainer", "switchStatus"];

  static values = {
    searchType: { type: String, default: "" },
    keywordFilterExclude: { type: String, default: "exclude" },
    keywordFilterInclude: { type: String, default: "include" }
  }

  initialize() {
    this.networkButtonTargets.forEach(btn => {
      if (btn.dataset.targetId === `tab-${this.searchTypeValue}`) {
        setTimeout(() => {
          btn.click();
        }, 1000)
      };
    });

    if (this.hasSwitchStatusTarget) {
      this.toggleswitchStatus();
    }
  }

  submitSearchForm() {
    const activeNetworkTab = document.querySelector("[data-tabs-target='tab']:not(.hidden)");
    const searchType = activeNetworkTab.dataset.targetId.split("-")[1];
    
    this.newSmartSearchFormTargets.forEach(form => {
      if (form.id.endsWith(searchType)) {
        if (searchType == "social_image") {
          this.emptyEntriesContainer();
        }
        else {
          form.requestSubmit();
        }
      }
    });
  }

  emptyEntriesContainer() {
    this.entriesContainerTarget.innerHTML = "";
  }

  toggleHashtagInput(event) {
    if (event.target.value === "#") {
      const activeNetworkTab = document.querySelector("[data-tabs-target='tab']:not(.hidden)");
      const searchType = activeNetworkTab.dataset.targetId.split("-")[1];

      this.hashtagInputContainerTargets.forEach(input => {
        if (input.id == searchType) {
          input.classList.remove("hidden");
        }
      });

      this.handleInputContainerTarget.classList.add("hidden");
      this.handleInputContainerTarget.querySelector("input").value = "";
    }
    else if (event.target.value === "@") {
      this.handleInputContainerTarget.classList.remove("hidden");

      this.hashtagInputContainerTargets.forEach(input => {
        input.classList.add("hidden");
        input.querySelector("input").value = "";
      });
    } 
    else {
      this.hashtagInputContainerTargets.forEach(input => {
        input.classList.add("hidden");
        input.querySelector("input").value = "";
      });
      
      this.handleInputContainerTarget.classList.add("hidden");
      this.handleInputContainerTarget.querySelector("input").value = "";

      this.submitSearchForm();
    }
  }

  toggleSwitchStatus() {
    if (this.switchStatusTarget.innerText == this.keywordFilterIncludeValue) {
      this.switchStatusTarget.innerText = this.keywordFilterExcludeValue;
      this.switchStatusTarget.classList.add("text-blue-400");
      this.switchStatusTarget.classList.remove("text-gray-400");
    }
    else {
      this.switchStatusTarget.innerText = this.keywordFilterIncludeValue;
      this.switchStatusTarget.classList.add("text-gray-400");
      this.switchStatusTarget.classList.remove("text-blue-400");
    }
  }
}